<template>
	<nk-nav
		v-if="typeof context.links !== 'undefined' && context.links.length > 0"
		:aria-label="context.titel || 'Weitere Links'"
		variant="resources"
		prepend-icon="link"
		append-icon="arrow-right"
	>
		<nk-nav-item
			v-for="(link, index) in context.links"
			:key="`link-${index}`"
			:link="link.link"
			:title="link.linktext"
			:text="link.link"
			:target="!link.isintern ? '_blank' : null"
		/>
	</nk-nav>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {array} context.links
 */
export default {
	name: 'NkTemplateLinks',

	mixins: [TemplatesDefault],
};
</script>
